import { Box, Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { ReferralNumber } from './ReferralNumber';
import { ReferralProvider } from './ReferralProvider';
import { ReferralState } from './ReferralState';
import { ReferralStatus } from './ReferralStatus';

export const SearchFields = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack direction='column' width='100%' gap={isDesktop ? '48px' : '24px'}>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? '48px' : '24px'}
        alignItems='center'
      >
        <Box width={'100%'}>
          <ReferralState />
        </Box>
        <Box width={'100%'}>
          <ReferralNumber />
        </Box>
      </Stack>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? '48px' : '24px'}
        alignItems='center'
      >
        <Box width={'100%'}>
          <ReferralProvider />
        </Box>
        <Box width={'100%'}>
          <ReferralStatus />
        </Box>
      </Stack>
    </Stack>
  );
};
